<template>
  <div id="home">
    <h3 id="tagline">Democratizing digital-era education like our future depends on it.</h3>
    <div id="home-text">
      <h1><strong>Welcome to Teach Tech NC!</strong></h1>
      <h2 id="welcome">WE'RE GLAD YOU'RE HERE.</h2>
      <h3>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
        ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
        voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      </h3>
      <h2>Ready to get started?</h2>
      <router-link to="/curriculum">
        <b-button id="signup-btn" pill variant="outline-light">
          LET'S GO!
        </b-button>
      </router-link>
    </div>
    <div id="home-more">
    </div>
    <div id="preload">
      <img src='@/assets/aria_chernik.jpg'/>
      <img src='@/assets/katie_zhou.jpg'/>
      <img src='@/assets/gargi_mahadeshwar.jpg'/>
      <img src='@/assets/vinitha_sunkara.png'/>
      <img src='@/assets/carter_zenke.jpg'/>
      <img src='@/assets/jonathan.png'/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import NavBar from '@/components/NavBar.vue'

export default {
    name: 'HomePage',
    components: {
    // HelloWorld,
    // NavBar
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@200&display=swap');
#home {
  text-align: left;
  margin-left: 1vw;
  margin-top: 0;
  padding-top: 0;
}

#tagline {
  margin: -10px auto 20px 2.5vw;
  max-width: 85%;
  color: #3fbfa6;
  font-size: 30px;
  font-family: 'Assistant', sans-serif;
  font-weight: bold;
}

#home-text {
  margin: 0 auto auto 5vw;
  max-width: 70%;
}

#welcome {
  margin: 10px 0 10px 0;
}

#preload {
  display: none;
}

@media only screen and (max-width: 800px) {

  #tagline {
    max-width: 95%;
    margin: 10px auto 20px 2.5vw;
    font-size: 4.5vw;
  }

  #home-text {
    margin: 0 auto auto 2.5vw;
    max-width: 80%;
  }

  #welcome {
    margin-bottom: 0;
  }

  h1 {
    font-size: 2.3em;
  }

  h3 {
    font-size: 1.2em;
  }
}

@media only screen and (max-width: 400px) {
  #tagline {
    font-size: 6vw;
    margin: 10px auto 10px 2.5vw;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.3em;
  }

  h3 {
    font-size: 1em;
  }

}

#signup-btn {
    font-size: 1.8em !important;
    padding: 0.5em;
    font-weight: bold;
    border-width: 2px;
    margin: 15px auto;
    color: #30b271;
    border-color: #30b271;
    background-color: #cef1df;
}

#signup-btn:hover {
    background-color: #53f0b1;
    color: #115777;
}

</style>
